
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CounterCartGrid extends Serenity.EntityGrid<CounterCartRow, any> {
        protected getColumnsKey() { return CounterCartColumns.columnsKey; }
        protected getDialogType() { return CounterCartDialog; }
        protected getIdProperty() { return CounterCartRow.idProperty; }
        protected getInsertPermission() { return CounterCartRow.insertPermission; }
        protected getLocalTextPrefix() { return CounterCartRow.localTextPrefix; }
        protected getService() { return CounterCartService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }


    }
}